module.exports = __webpack_public_path__ + "img/logo-hamrahe-aval.658ffe3.png";